import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AccountTypeService } from '@http/clients/account-type.service';
import { AccountTypeView } from '@http/clients/api-proxies';
import { GenericDropdownComponent } from 'ngx-lib';
import { createValueAccessorProvider, FormEditorBase } from '../base/form-editor-base';

@Component({
    selector: 'app-account-type-form-editor',
    templateUrl: './account-type-form-editor.component.html',
    styleUrl: './account-type-form-editor.component.scss',
    providers: [createValueAccessorProvider(AccountTypeFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class AccountTypeFormEditorComponent extends FormEditorBase<AccountTypeView[]> implements OnInit {
    // Inputs for direct signal usage
    value = input<AccountTypeView[]>();
    readonly = input<boolean>();
    placeholderText = input<string>('Select Type');

    private readonly accountTypeService = inject(AccountTypeService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadAccountTypes();
    }

    onSelectedItemChange(selectedItem: any): void {
        if (selectedItem && selectedItem !== null) {
            this.selectedItems.set([selectedItem]);
        } else {
            this.selectedItems.set([]);
        }
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): AccountTypeView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: AccountTypeView[]): any[] {
        return value || [];
    }

    private async loadAccountTypes(): Promise<void> {
        const items = await this.accountTypeService.getAll();
        this.items.set(items);
    }
}
